import PropTypes from 'prop-types';
import React from 'react';

import BrIcons from '@components/BrIcons';
import BrLabel from '@components/BrLabel';
import BrText from '@components/BrText';
import BrTooltip from '@components/BrTooltip';

const READONLY_TOOLTIP_MULTISITE = (
  <div>
    This rule is read only because your current site context
    {' '}
    <br />
    (displayed at the right side of the top nav)
    {' '}
    <br />
    does not match the rule's site influence
  </div>
);
const READONLY_TOOLTIP_TESTING = 'This rule is read only because it is associated with an A/B test';

export default function MultilineMetadataColumn({ row, cell }) {
  const { isEditable, isLive, audiences } = row.Original_Data;
  const startedAt = row.StartedAt.value;
  const endedAt = row.EndedAt.value;
  const groupBy = row.groupBy;
  const durationStr = `${String(startedAt)} - ${String(endedAt)}`;
  const isReadOnly = !isEditable || isLive;

  const audienceEle = audiences.length <= 0 ? null : (
    <div className="audience-block" key="audience">
      <BrLabel className="audience-name" preIcon={<BrIcons.Audience />} title={audiences[0].audienceName} />
    </div>
  );

  const durationEle = startedAt === null && endedAt === null ? null : (
    <div className="duration-block" key="duration">
      <BrLabel className="duration-details" preIcon={<BrIcons.Calendar />} title={durationStr} />
    </div>
  );

  const groupByEle = groupBy === null || groupBy === undefined ? null : (
    <div className="groupby-block" key="group-by">
      <BrLabel classname="" title={`Group-by: ${groupBy}`} />
    </div>
  );

  const readOnlyNote = isReadOnly && (
    <BrTooltip className="read-only-label" location={BrTooltip.Locations.right}>
      <BrIcons.ReadOnly />
      <BrTooltip.Tooltip>{row.isLive.value ? READONLY_TOOLTIP_TESTING : READONLY_TOOLTIP_MULTISITE}</BrTooltip.Tooltip>
    </BrTooltip>
  );

  const separator = (id) => (
    <div key={`separator-${id}`} className="separator-div">
      |
    </div>
  );

  const metadataRows = [audienceEle, durationEle, groupByEle].reduce((arr, ele) => {
    if (ele) {
      if (arr.length) {
        arr.push(separator(arr.length / 2));
      }
      arr.push(ele);
    }
    return arr;
  }, []);

  return (
    <div className="br-table-editor-multiline-metadata-type-column">
      <div className="title-row">
        {readOnlyNote}
        <BrText className="title-text-header" title={cell.value}>
          {cell.value}
        </BrText>
      </div>

      <div className="metadata-rows">{metadataRows}</div>
    </div>
  );
}

MultilineMetadataColumn.defaultWidth = 240;

MultilineMetadataColumn.propTypes = {
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.any,
  }).isRequired,
  row: PropTypes.shape({
    // row data
    Original_Data: PropTypes.shape({
      variants: PropTypes.any,
      isEditable: PropTypes.any,
      isLive: PropTypes.any,
    }).isRequired,
  }).isRequired,
};
